import React, { Component } from "react";
import cx from "classnames";

export default class Danke extends Component {
  render() {
    let style = cx("danke", "content", { hidden: !this.props.active });
    return (
      <div>
        <section className={style}>
          <h3>
            Votre rendez-vous chez Dr. Weyrich a été confirmé, Vous recevrez un
            email.
          </h3>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/module/danke/index.js